import { createReducer } from "@reduxjs/toolkit";
import { Types } from "./Actions";
import INITIAL_STATE from "./InitialState";

export const UsuariosReducer = createReducer(INITIAL_STATE, (builder) => {
  /**
   * Consultar lista de usuarios
   */
  builder
    .addCase(Types.CONSULTAR_USUARIOS_LOADING, (state) => {
      state.consultarUsuariosLoading = true;
      state.consultarUsuariosError = null;
    })
    .addCase(Types.CONSULTAR_USUARIOS_SUCCESS, (state, action) => {
      const { consultarUsuariosData } = action;
      state.consultarUsuariosData = consultarUsuariosData;
      state.consultarUsuariosLoading = false;
      state.consultarUsuariosError = null;
    })
    .addCase(Types.CONSULTAR_USUARIOS_FAILURE, (state, action) => {
      const { consultarUsuariosError } = action;
      state.consultarUsuariosData = INITIAL_STATE.consultarUsuariosData;
      state.consultarUsuariosLoading = false;
      state.consultarUsuariosError = consultarUsuariosError;
    });

  /**
   * Obtener recursos (permisos y roles)
   */
  builder
    .addCase(Types.OBTENER_RECURSOS_LOADING, (state) => {
      state.obtenerRecursosLoading = true;
      state.obtenerRecursosError = null;
    })
    .addCase(Types.OBTENER_RECURSOS_SUCCESS, (state, action) => {
      const { obtenerRecursosData } = action;
      state.obtenerRecursosData = obtenerRecursosData;
      state.obtenerRecursosLoading = false;
      state.obtenerRecursosError = null;
    })
    .addCase(Types.OBTENER_RECURSOS_FAILURE, (state, action) => {
      const { obtenerRecursosError } = action;
      state.obtenerRecursosData = INITIAL_STATE.obtenerRecursosData;
      state.obtenerRecursosLoading = false;
      state.obtenerRecursosError = obtenerRecursosError;
    });

  /**
   * Asignar rol a usuario
   */
  builder
    .addCase(Types.ASIGNAR_ROL_LOADING, (state) => {
      state.asignarRolLoading = true;
      state.asignarRolError = null;
    })
    .addCase(Types.ASIGNAR_ROL_SUCCESS, (state, action) => {
      const { asignarRolData } = action;
      state.asignarRolData = asignarRolData;
      state.asignarRolLoading = false;
      state.asignarRolError = null;
    })
    .addCase(Types.ASIGNAR_ROL_FAILURE, (state, action) => {
      const { asignarRolError } = action;
      state.asignarRolData = INITIAL_STATE.asignarRolData;
      state.asignarRolLoading = false;
      state.asignarRolError = asignarRolError;
    });

  /**
   * Remover rol de usuario
   */
  builder
    .addCase(Types.REMOVER_ROL_LOADING, (state) => {
      state.removerRolLoading = true;
      state.removerRolError = null;
    })
    .addCase(Types.REMOVER_ROL_SUCCESS, (state, action) => {
      const { removerRolData } = action;
      state.removerRolData = removerRolData;
      state.removerRolLoading = false;
      state.removerRolError = null;
    })
    .addCase(Types.REMOVER_ROL_FAILURE, (state, action) => {
      const { removerRolError } = action;
      state.removerRolData = INITIAL_STATE.removerRolData;
      state.removerRolLoading = false;
      state.removerRolError = removerRolError;
    });

  /**
   * Obtener usuario por username
   */
  builder
    .addCase(Types.OBTENER_USUARIO_LOADING, (state) => {
      state.obtenerUsuarioLoading = true;
      state.obtenerUsuarioError = null;
    })
    .addCase(Types.OBTENER_USUARIO_SUCCESS, (state, action) => {
      const { obtenerUsuarioData } = action;
      state.obtenerUsuarioData = obtenerUsuarioData;
      state.obtenerUsuarioLoading = false;
      state.obtenerUsuarioError = null;
    })
    .addCase(Types.OBTENER_USUARIO_FAILURE, (state, action) => {
      const { obtenerUsuarioError } = action;
      state.obtenerUsuarioData = INITIAL_STATE.obtenerUsuarioData;
      state.obtenerUsuarioLoading = false;
      state.obtenerUsuarioError = obtenerUsuarioError;
    });
});
